var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"placeholder-message"},[_c('md-icon',{staticClass:"placeholder-message__icon"},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_c('span',{staticClass:"placeholder-message__text"},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }